// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupItem_container__3X3sb","info":"GroupItem_info__11gKI","desc":"GroupItem_desc__1ll7z","name":"GroupItem_name__S420h","link":"GroupItem_link__1T3ih"};